package org.example.zone360.components

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class DownloadPdfRequest(
    val pdfPayload: JsonElement,
)
